import React from "react";

import Header from "../components/Header.jsx";
import "../styles/pages/error_page.css";

const ErrorPage = () => {
  return (
    <div className="error-page">
      <Header />
      <div className="error-page-content">
        <div className="error-info-block">
          <span className="error-number"><i>404</i></span>
          <span className="error-title">Страница не найдена!</span>
          <span className="error-text">Что-то пошло не так...</span>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
